<template>
  <div class="page">
    <Nav isActive="1" :isIndex="isIndex" />
    <div style="position: relative" class="pb100">
      <img
        src="http://h5.shihua.com/static/yunxue/zxbg.png"
        style="width: 100%"
      />
      <div style="position: absolute; top: 150px; left: 0; width: 100%">
        <div class="pageWD">
          <div class="cter cff" style="padding-bottom: 30px">
            <div class="f36 pb10">免费咨询</div>
            <div class="f20">Free consultation</div>
          </div>
        </div>
      </div>
    </div>
    <div class="pageWD pb100">
      <div
        class="f36 cter"
        style="color: #333; padding: 0px 0 10px 0; font-weight: 700"
      >
        数智营销教育的开创者 · 带您构建品牌私域流量
      </div>
      <div class="f20 cter" style="color: #8b8b8b;margin-bottom:50px">
        Founder of Digital Intelligence Marketing Education,Take you to build
        brand private domain traffic
      </div>      
      <div class="flex-sb">
        <div v-for="(item, index) in fwlist" class="zxxlist" :key="index">
          <img class="img" :src="item.imgUrl" style="height:48px;margin-top:50px" />
          <div class="f16 nn">{{ item.name }}</div>
          <div class="f12 c6 sub sub1">{{ item.sub1 }}</div>
          <div class="f12 c6 sub sub2">{{ item.sub2 }}</div>
        </div>
      </div>
    </div>
    <div class="onform">
      <div class="cff cter" style="padding: 40px 0 30px 0">
        <div class="f36 pb10">提交需求</div>
        <div class="f20">Submit Requirements</div>
      </div>
      <div class="ff">
        <div style="padding-top:50px">
          <span>公司名称</span><input type="text" placeholder="您的公司或品牌" style="width: 100%" v-model="page.company"/>
        </div>
        <div>
          <span>联系人</span><input type="text" placeholder="您的姓名" style="width: 100%" v-model="page.xm"/>
        </div>
        <div>
          <span>职务</span><input type="text" placeholder="您的职务" style="width: 100%" v-model="page.position"/>
        </div>
        <div>
          <span>联系电话</span><input type="text" placeholder="您的手机号码" style="width: 100%" v-model="page.phone"/>
        </div>        
        <div>
          <input
            type="button"
             @click="subMe"
                  value="提交"
                  :disabled="isDis"
            style="border: 0; width: 100%; background: #4db4e4; color: #fff;margin:50px 110px 0 100px"
          />
        </div>
      </div>
    </div>
    <Fotter />
  </div>
</template>
<script>
import { addAdvisePost } from "@/api/api";
import Nav from "@/components/Nav.vue";
import Fotter from "@/components/Fotter.vue";
export default {
  name: "onlineing",
  components: { Nav, Fotter },
  data() {
    return {
      isDis: false,
      page: {
        xm: "",
        company: "",
        position: "",
        phone: ""
      },
      formdata: {
        memberId: 0,
        name: "",
        phone: "",
        adviceContent: "需求",
        adviceType: 4,
      },
       fwlist: [
        {
          name: "企业转型陪跑",
          imgUrl: "http://h5.shihua.com/static/yunxue/onlineicon1.png",
          sub1: "整合企业、社会等多方资源，搭建平台，健全服务体系，推动集聚政策...",
          sub2: "整合企业、社会等多方资源，搭建平台，健全服务体系，推动集聚政策、技术、资本等要素，为企业开设转型陪跑通道，助推企业加速前进，创新数智化发展路径。",
        },
        {
          name: "定向创新孵化",
          imgUrl: "http://h5.shihua.com/static/yunxue/onlineicon2.png",
          sub1: "云学科技为创业者提供开放合作平台，充分发挥教育行业的资源优势，让...",
          sub2: "云学科技为创业者提供开放合作平台，充分发挥教育行业的资源优势，让广大企业和创业者相互学习合作，共同推进“双创”工作。提供创新孵化器团队和运作机制让每一个项目从0到1创新加速，探索可行模式到产品市场验证成型。",
        },
        {
          name: "全案代运营服务",
          imgUrl: "http://h5.shihua.com/static/yunxue/onlineicon3.png",
          sub1: "策划量身定制互动营销，专人专项策划实施，资深设计把控视觉，专业编...",
          sub2: "策划量身定制互动营销，专人专项策划实施，资深设计把控视觉，专业编辑操刀撰写，视觉统筹精致排版，热点内容专题系列，助力引流获客，场景内会员激活 ，广告平台精准投放。",
        },
        {
          name: "营销教育学院",
          imgUrl: "http://h5.shihua.com/static/yunxue/onlineicon4.png",
          sub1: "云学科技整合行业课程资源，搭建线上营销教育学院，汇集百位行业大咖导师...",
          sub2: "云学科技整合行业课程资源，搭建线上营销教育学院，汇集百位行业大咖导师，海量精品课程，覆盖全岗位需求，通过零距离授课讲解，满足移动化课程学习需求。",
        },
      ],
      isIndex: 1
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
     subMe() {
      var that = this;
      if (this.page.xm == "") {
        this.$message({
          message: "请输入姓名！",
          offset: 300,
          type: "warning",
        });
        return;
      }
      if (this.page.company == "") {
        this.$message({
          message: "请输入公司名称！",
          offset: 300,
          type: "warning",
        });
        return;
      }
      if (this.page.phone.length != "11") {
        this.$message({
          message: "请输入正确手机号码！",
          offset: 300,
          type: "warning",
        });
        return;
      }
      if ((this.page.phone + "").substr(0, 1) != "1") {
        this.$message({
          message: "请输入正确手机号码！",
          offset: 300,
          type: "warning",
        });
        return;
      }
      if (this.page.position == "") {
        this.$message({
          message: "请输入职位！",
          offset: 300,
          type: "warning",
        });
        return;
      }
     
      var url =
        "https://qiyeapi.yunxuekeji.cn/yunxue_co_api/systemConfig/addAdvise";
      this.formdata.name =
      this.page.xm + "&" + this.page.company + "&" + this.page.position;
      this.formdata.phone = this.page.phone;
      this.isDis = true;
      this.$axios({
        url: url, //请求地址
        method: "POST", //请求方法
        responseType: "json", //返回值类型
        params: this.formdata,
      })
        .then((res) => {
          that.$message({
            message: "提交成功，客服会尽快联系您！",
            offset: 300,
            type: "success",
          });
          that.isDis = false;
          that.page= {
            xm: "",
            company: "",
            position: "",
            phone: ""           
          }
        })
        .catch((error) => {
          that.isDis = false;
          console.log(error); //请求失败
        });

      // addAdvisePost(data).then((res) => {
      //   console.log(res);
      //   this.$message({
      //     message: "提交成功，客服会尽快联系您！",
      //     offset: 300,
      //     type: "success",
      //   });
      //   this.isDis = false;
      // });
    },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 60) {
        this.isIndex = 2;
      } else {
        this.isIndex = 1;
      }
    },
  },
};
</script>
<style scoped>
.onform {
  height: 750px;
  background: url("http://h5.shihua.com/static/yunxue/zxbg2.png") left top
    no-repeat;
  background-size: cover;
}
.onform .ff {
  width: 889px;
  height: 520px;
  background: #ffffff;
  border-radius: 16px;
  margin: 0 auto;
}
.onform .ff div{
  margin-left:50px;
  display: flex;
  margin-bottom: 20px;
  align-items: center;
}
.onform .ff span{
  width:100px;
  color:#333;
  font-size:18px
}
.onform input {
  color: #B7B7B7;
  font-size: 18px;
  padding: 17px 10px;
  border: 1px solid #E3E3E3;
  flex:1;
  margin-right: 110px;
  background: transparent;
  border-radius: 6px;

}
.zxxlist {
  width: 290px;
  height: 317px;
  border-radius: 6px;
  text-align: center;
  background: url("http://h5.shihua.com/static/yunxue/onlinebg.png") left top
    no-repeat;
  background-size: cover;
}
.zxxlist .sub {
  padding: 0 24px;
  line-height: 26px;
  position: relative;
  padding-top:20px;
  margin-top: 10px;
}
.zxxlist .nn{
  font-weight: 700;
  padding: 25px 0 10px 0
}
.zxxlist:hover {
  /* border-top: 5px solid #25a2dd;
  border-bottom: 5px solid #25a2dd; */
  /* position: relative;
    top:-10px; */
  /* transform:translateY(-10px) */
  background: #7F8182;
  position: relative;
  animation: mymoves 0.8s 1;
  -webkit-animation: mymoves 0.8s 1; /*Safari and Chrome*/
  animation-iteration-count: 1;
  -webkit-animation-iteration-count: 1; /*Safari and Chrome*/
  animation-fill-mode: forwards ;
  -webkit-animation-fill-mode: forwards ;
}
.zxxlist .sub2{
  display: none;
}
.zxxlist:hover .sub1,.zxxlist:hover .img{
  display: none;
}
.zxxlist:hover .nn{
  color:#fff;
  padding: 50px 0 10px 0
}
.zxxlist:hover .sub2{
  display: block;
  color:#fff;
  margin:0 10px;
  line-height: 26px;
}
@keyframes mymoves {
  from {
    top: 0px;
  }
  to {
    top: -10px;
  }
}
@-webkit-keyframes mymoves /*Safari and Chrome*/ {
  from {
    top: 0px;
  }
  to {
    top: -10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/onlineing/index.vue